import moment from 'moment';

const currentMomentLocale = moment.locale();

export default currentMomentLocale;
